import { render, staticRenderFns } from "./deleteAccountWithdrawalApply.vue?vue&type=template&id=6c7ba612"
import script from "./deleteAccountWithdrawalApply.vue?vue&type=script&lang=js"
export * from "./deleteAccountWithdrawalApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports